import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {annotate} from "rough-notation";
import {RookieDistrictsService} from "../../services/rookie/rookie-districts.service";

@Component({
  selector: 'brt-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements AfterViewInit{

  @ViewChild('titleEl') titleEl!: ElementRef<null>;
  readonly isRookie: boolean = !!this.route.snapshot.data['rookie'];

  routerLink = "";

  constructor(
    private rookieDistrictsService: RookieDistrictsService,
    private route: ActivatedRoute
  ) {

    console.warn(this.isRookie);
    if(this.isRookie) {
      this.routerLink = '/rookie/' + this.rookieDistrictsService.getCurrentDistrictData()!.name.toLowerCase();
    }
  }

  ngAfterViewInit() {
    if(this.titleEl && this.titleEl.nativeElement) {
      const htmlEl = this.titleEl.nativeElement as HTMLElement;
      const newAnnotate = annotate(htmlEl.querySelector("em") ?? htmlEl, {
        type: "highlight",
        animationDuration: 300,
        iterations: 2,
        color: "#BACFD3",
        padding: 15,
        multiline: true
      });
      setTimeout(() => {
        newAnnotate.show();
      }, 300);
    }
  }

}
